// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9166e3f1","453":"fdd1e38a","455":"4880df88","977":"32cd0077"}[chunkId] + ".chunk.js";
};